import React from 'react';

const JoinAdventure = () => {
  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 bg-gradient-to-br from-blue-900 to-purple-900 text-white">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row gap-10 items-center">
          {/* Illustration/Image */}
          <div className="md:w-2/5 flex justify-center">
            <div className="relative w-full max-w-xs">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-yellow-400 rounded-full opacity-20 animate-pulse"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-green-500 rounded-full opacity-20 animate-pulse delay-300"></div>
              <div className="relative rounded-2xl shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=500"
                  alt="Communauté de makers africains"
                  className="rounded-xl shadow-md w-full h-auto"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="md:w-3/5 text-center md:text-left">
            <h2 className="text-title text-dark-1 font-bold mb-6">
              Rejoindre l'<span className="text-white">aventure</span>
            </h2>

            <p className="text-subtitle mb-8 leading-relaxed">
              "Que tu sois collégien, étudiant, parent, enseignant ou professionnel :
              Lance toi dans l'aventure Maker. Ensemble, construisons la prochaine
              génération de makers africains."
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <a
                href="https://app.gonextmaker.com/auth/signup"
                className="hover:bg-red-4 text-white font-semibold py-3 px-6 rounded-full transition-all border-2
                border-red-4 flex items-center justify-center"
              >
                Rejoindre la communauté
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </a>

              <a
                href="https://app.gonextmaker.com/auth/signup"
                className="hover:bg-red-4 text-white font-semibold py-3 px-6 rounded-full transition-all border-2
                border-red-4 flex items-center justify-center"
              >
                Devenir tuteur
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                </svg>
              </a>

              <a
                href="https://app.gonextmaker.com/auth/signup"
                className="hover:bg-red-4 text-white font-semibold py-3 px-6 rounded-full transition-all border-2
                border-red-4 flex items-center justify-center"
              >
                Soutenir le mouvement
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinAdventure;